import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const login = createAsyncThunk("login", async (payload) => {
    const response = await api.login(payload)
    return response
})

export const logout = createAsyncThunk("logout", async (payload) => {
    const response = await api.logout(payload)
    return response
})

export const twoFactorAuth = createAsyncThunk("twoFactorAuth", async (payload) => {
    const response = await api.twoFactorAuth(payload)
    return response
})

export const getCurrentUser = createAsyncThunk("getCurrentUser", async () => {
    const response = await api.getCurrentUser()
    return response
})

export const updateUser = createAsyncThunk("updateUser", async (payload) => {
    const response = await api.updateUser(payload)
    return response
})

export const forgotPassword = createAsyncThunk("forgot-password", async (payload) => {
    const response = await api.forgotPassword(payload)
    return response
})

export const resetPassword = createAsyncThunk("reset-password", async (payload) => {
    const response = await api.resetPassword(payload)
    return response
})

export const refreshToken = createAsyncThunk("refresh-token", async (payload) => {
    const response = await api.refreshToken(payload)
    return response
})

export const getGaiUserByID = createAsyncThunk("getGaiUserByID", async (payload) => {
    const response = await api.getGaiUserByID(payload)
    return response
})

const authenticationSlice = createSlice({
    name: "authentication",
    initialState: {
        user: {},
        isAuthenticated: false,
        role: "",
        beingUpdatedSettings: {},
        fetchStatus: "",
        action: ""
    },
    reducers: {
        setUser(state, action) {
            state.user = action.payload
        },
        updateSetting(state, action) {
            const { field, value } = action.payload
            state.beingUpdatedSettings = { ...state.beingUpdatedSettings, [field]: value }
        },
        assignUpdatedSettings(state, action) {
            state.beingUpdatedSettings = action.payload
        },
        reassignUpdatedSetting(state, action) {
            state.beingUpdatedSettings = action.payload
        },
        restrainUser(state, action) {
            state.isAuthenticated = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.fulfilled, (state, action) => {
                if (action.payload?.refreshToken) {
                    state.isAuthenticated = true
                    state.role = action?.payload?.role
                }
                state.fetchStatus = "success"
                state.action = "login"
            })
            .addCase(login.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "login"
            })
            .addCase(login.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "login"
            })
            .addCase(logout.fulfilled, (state) => {
                state.user = {}
                state.isAuthenticated = false
                window.sessionStorage.removeItem("ACCESS_TOKEN")
                window.sessionStorage.removeItem("REFRESH_TOKEN")
                window.sessionStorage.removeItem("site")
                state.fetchStatus = "success"
                state.action = "logout"
            })
            .addCase(logout.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "logout"
            })
            .addCase(logout.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "logout"
            })
            .addCase(twoFactorAuth.fulfilled, (state, action) => {
                if (action.payload?.succeeded) {
                    state.isAuthenticated = true
                    state.role = action?.payload?.role
                }
                state.fetchStatus = "success"
                state.action = "twoFactorAuth"
            })
            .addCase(twoFactorAuth.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "twoFactorAuth"
            })
            .addCase(twoFactorAuth.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "twoFactorAuth"
            })
            .addCase(refreshToken.fulfilled, (state) => {
                state.fetchStatus = "success"
                state.action = "refreshToken"
            })
            .addCase(refreshToken.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "refreshToken"
            })
            .addCase(refreshToken.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "refreshToken"
            })
            .addCase(getCurrentUser.fulfilled, (state, action) => {
                if (!action.payload || !action.payload?.succeeded) {
                    state.user = {}
                    state.isAuthenticated = false
                    state.fetchStatus = "error"
                } else if (action.payload?.succeeded) {
                    state.user = action.payload.item
                    state.isAuthenticated = true
                    state.role = action?.payload?.item?.role
                    state.fetchStatus = "success"
                }
                state.action = "getCurrentUser"
            })
            .addCase(getCurrentUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getCurrentUser"
            })
            .addCase(getCurrentUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getCurrentUser"
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                if (action.payload?.succeeded) {
                    state.user = state.beingUpdatedSettings
                } else {
                    // state.user = action.payload
                }
                state.fetchStatus = "success"
                state.action = "updateUser"
            })
            .addCase(updateUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "updateUser"
            })
            .addCase(updateUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "updateUser"
            })
            .addCase(forgotPassword.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "forgotPassword"
            })
            .addCase(forgotPassword.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "forgotPassword"
            })
            .addCase(forgotPassword.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "forgotPassword"
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "resetPassword"
            })
            .addCase(resetPassword.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "resetPassword"
            })
            .addCase(resetPassword.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "resetPassword"
            })
            .addCase(getGaiUserByID.fulfilled, (state, action) => {
                state.user.role = action.payload.item.role
                state.fetchStatus = "success"
                state.action = "getGaiUserByID"
            })
            .addCase(getGaiUserByID.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getGaiUserByID"
            })
            .addCase(getGaiUserByID.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getGaiUserByID"
            })
    }
})

export default authenticationSlice
export const { name, actions, reducers } = authenticationSlice
